import HTTP_REQUEST from "../../utils/http";
import * as jobTypes from "../types/jobs";
import helpers from "../../utils/helpers";
import { changeGlobalState } from "./global";
import { decryptCredentials } from "../../utils/cifrate";
import { formatToSelectCustom } from "../../utils/Utils";
import url from "../../utils/url";

export const loadingJobs = () => ({
    type: jobTypes.LOADING_JOB,
});

export const successGetJobs = (payload) => ({
    type: jobTypes.SUCCESS_JOB,
    payload,
});

export const setJobSelected = payload => dispatch => {
    dispatch({
        type: jobTypes.SET_SELECTED_JOB,
        payload
    })
};

export const setWorkStatus = payload => dispatch => {
    dispatch({
        type: jobTypes.SET_WORK_STATUS,
        payload
    })
};

export const setCompanyName = payload => dispatch => {
    dispatch({
        type: jobTypes.SET_COMPANY,
        payload
    })
};

export const getJobs = () => async (dispatch) => {
    dispatch(loadingJobs());
    const bodyRequest = helpers.getBodySimple({});
    bodyRequest.headers = { 'x-api-key': decryptCredentials(process.env.REACT_APP_API_KEY_CROSS_CANAL) };
    try {
      const { payload } = await HTTP_REQUEST.AmplifyApi({
        name: "CANAL_CROSS",
        path: url.getJobs,
        data: bodyRequest,
      });
      const jobsFormated = formatToSelectCustom(payload?.payload || [], {
	    value: "idOcupacion",
	    text: "descripcion",
        label: "descripcion",
      });
      dispatch(successGetJobs(jobsFormated));
    } catch(error) {
      dispatch(changeGlobalState(4));
      helpers.sendTagError(error, url.getJobs);
    }
  };
